<template>
  <a
    :href="glossaryUrl"
    class="glossary-link"
    title="Glossary"
    aria-label="Glossary"
  >
    <svg
      class="glossary-link__icon"
      xmlns="http://www.w3.org/2000/svg"
      width="17.82"
      height="22.5"
      viewBox="0 0 36.218 45.728"
      alt=""
    >
      <g
        data-name="Group 5165"
        transform="translate(-1270 -1321)"
      >
        <path
          data-name="Path 3876"
          d="M0,0H31.9V45.728L16.251,37.7,0,45.728Z"
          transform="translate(1270 1321)"
        />
        <path
          data-name="Path 3877"
          d="M410.1-8956.854l-4.32-5.119v5.119Z"
          transform="translate(896.12 10282.974)"
        />
      </g>
    </svg>
  </a>
</template>

<script>
export default {
  name: 'GlossaryLink',
  props: {
    isTeReo: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    glossaryUrl() {
      const miUrlPart = this.isTeReo ? '/mi' : '';
      return `${miUrlPart}/glossary`;
    },
  },
};
</script>

<style lang="scss" scoped>
.glossary-link {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;

  @include breakpoint-tablet-down {
    display: none;
  }

  @include hover-focus-active {
    border: none;
  }

  &__icon {
    fill: $color-primary-blue;

    @include hover-focus-active {
      fill: $color-blue-button-dark;
    }
  }
}
</style>
